<div class="d-flex">
  <div>
    <app-superadminsidenav></app-superadminsidenav>
  </div>
  <div style="
      height: 100vh;
      overflow: scroll;
      width: 100%;
      background-color: rgba(250, 250, 250, 1);
    ">
    <div style="padding-left: 10px" class="container">
      <div *ngIf="restopop == 0">
        <div class="allergens-head">
          <div class="allergensBtn" [ngClass]="{ bgSelectClass: restoSeletedFlag }" (click)="restoList()">
            Restaurants List
          </div>
          <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: !restoSeletedFlag }" (click)="materResto()">
            Chains & Groups
          </div>
        </div>
        <ng-container *ngIf="restoSeletedFlag">
          <!-- <div class="headTitle">Restaurants List</div> -->
          <div class="containerResto">
            <div class="container-head">
              <span class="noOfRestoList">{{noResto}} Restaurants</span>
              <span class="resto-input">
                <div style="padding: 2px">
                  <img src="../../../assets/images/Search.png" alt="" />
                  <input placeholder="Restaurant name or ID" [(ngModel)]="searchText" (ngModelChange)="filter()" />
                </div>
              </span>
              <div (click)="addResto()" class="addRestoBtn">
                <div>
                  <img src="../../../assets/images/Plus.png" alt="" />
                  <span>Add Restaurants</span>
                </div>
              </div>
            </div>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
              <!-- Position Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  SL No.
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                  {{ i + 1 }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Restaurants Name
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                  {{ element.restaurant_name }}
                </td>
              </ng-container>
              `
              <!-- Weight Column -->
              <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Restaurants<br />
                  Information
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                  <img src="../../../assets/images/editIcon.png" alt="" class="edit-element"
                    (click)="updateRestoFunc(element.restaurant_id)" />
                </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Active<br> Status
                </th>
                <td mat-cell *matCellDef="let element" class="table-element status-element"
                  [ngClass]="{ active: element.restaurant_status == 'Active' }">
                  <!-- {{ element.restaurant_status }} -->
                  <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                      [checked]="element.restaurant_status == 'Active'"
                      (change)="statusHandleFunc($event.target,element.restaurant_id)" style="cursor: pointer;">
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
                  Action
                </th>
                <td mat-cell *matCellDef="let element" class="table-element action-element">
                  <img *ngIf="element.restaurant_status == 'Active'" src="../../../assets/images/deletIcon.png" alt=""
                    (click)="openDialog(element.restaurant_id)" />
                  <img *ngIf="element.restaurant_status != 'Active'" src="../../../assets/images/undo.svg" alt=""
                    (click)="activateRestoFunc(element.restaurant_id)" />
                </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
                  Send Menu <br /> Email
                </th>
                <td mat-cell *matCellDef="let element" class="table-element action-element">
                  <ng-container *ngIf="element.is_menu_added == 1;">
                    <span>&nbsp;</span>
                  </ng-container>
                  <ng-container *ngIf="element.is_menu_added == 0;">
                    <img src="../../../assets/img/mail-all-svgrepo-com.svg" alt="" style="width: 25px; cursor: pointer;"
                      (click)="sendEmail(element)">
                  </ng-container>
                </td>
              </ng-container>

              <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  View
                </th>
                <td mat-cell *matCellDef="let element" class="table-element view-element">
                  <img src="../../../assets/images/viewIcon.png" alt=""
                    (click)="viewRestoFunc(element.restaurant_id)" />
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator #paginator [pageSizeOptions]="[12, 20, 25]" showFirstLastButtons></mat-paginator>
          </div>
        </ng-container>

        <ng-container *ngIf="!restoSeletedFlag">
          <div class="containerResto">
            <div class="container-head">
              <span class="noOfRestoList">{{noMasterResto}} Restaurants</span>
              <span class="resto-input">
                <div style="padding: 2px">
                  <img src="../../../assets/images/Search.png" alt="" />
                  <input placeholder="Restaurant name or ID" [(ngModel)]="searchText" (ngModelChange)="filter()" />
                </div>
              </span>
              <div (click)="addMasterResto()" class="addRestoBtn" style="width:23vw;">
                <div>
                  <img src="../../../assets/images/Plus.png" alt="" />
                  <span>Add Chains & Groups</span>
                </div>
              </div>
            </div>
            <table mat-table [dataSource]="masterRestodataSource" class="mat-elevation-z8 demo-table">
              <!-- Position Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  SL No.
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                  {{ i + 1 }}
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Restaurants Name
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                  {{ element.master_resto_name }}
                </td>
              </ng-container>


              <!-- Email Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Email
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                  {{ element.email }}
                </td>
              </ng-container>

              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                  Edit
                </th>
                <td mat-cell *matCellDef="let element" class="table-element view-element">
                  <img src="../../../assets/img/edit-3-svgrepo-com.svg" style="width: 25px;" alt="" (click)="editMasterRestoFunc(element)" />
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="masterDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: masterDisplayedColumns"></tr>
            </table>
            <mat-paginator #paginator1 [pageSizeOptions]="[12, 20, 25]" showFirstLastButtons></mat-paginator>
          </div>

        </ng-container>
      </div>
      <div *ngIf="restopop == 1" class="addRestoMainContainer">
        <div class="restoHeadText">Restaurants Details</div>
        <div style="padding:0 20px">
          <form #restoAddData="ngForm">
            <div class="grid">
              <div class="input-container">
                <label for="restoName">Restaurant Name<span class="starReq">*</span></label>
                <input type="text" id="restoName" name="restoName" placeholder="enter the restaurant name"
                  class="form-control" [(ngModel)]="restoName" #name="ngModel" required />
                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="reqAlert">Name is required</div>
              </div>
              <div class="input-container">
                <label for="emailId">Email ID<span class="starReq">*</span></label>
                <input type="email" name="emailId" placeholder="enter the email-id" class="form-control"
                  [(ngModel)]="restoEmail" #email="ngModel" required />
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="reqAlert">Email is required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Telephone<span class="starReq">*</span></label>
                <input type="number" placeholder="enter restaurant telephone" class="form-control"
                  [(ngModel)]="restoPhone" (keypress)="validateNum($event)" name="restoTel" #restoTel="ngModel"
                  required />
                <div *ngIf="restoTel.invalid && (restoTel.dirty || restoTel.touched)" class="reqAlert">Telephone is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Logo<span class="starReq">*</span></label>
                <div>
                  <span class="imgPreview"><img [src]="src" alt="" /></span>
                  <span>
                    <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event)" #fileInput_image
                      hidden name="imgFile" />
                    <button class="uploadBtn" (click)="fileInput_image.click()">
                      <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                    </button>
                  </span>

                </div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Address<span class="starReq">*</span></label>
                <textarea class="form-control" id="newRrestoAddress" rows="3" [(ngModel)]="restoAddress" name="restoAdd"
                  #restoAdd="ngModel" required></textarea>
                <div *ngIf="restoAdd.invalid && (restoAdd.dirty || restoAdd.touched)" class="reqAlert">Address is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Descriptions</label>
                <textarea class="form-control" id="newRrestoDescription" rows="3" [(ngModel)]="restoDescrip"
                  name="rstoDescp"></textarea>
              </div>
              <div class="input-container">
                <label for="restoName">POC Name</label>
                <input type="text" placeholder="enter the POC name" class="form-control" name="pocName"
                  [(ngModel)]="restoPocName" />
              </div>
              <div class="input-container">
                <label for="restoName">POC ID</label>
                <input type="number" placeholder="enter the POC ID" class="form-control" name="pocId"
                  [(ngModel)]="restoPocId" />
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Latitude<span class="starReq">*</span></label>
                <input type="number" placeholder="enter restaurant latitude" class="form-control"
                  [(ngModel)]="restoLotitude" name="restoLat" #restoLat="ngModel" required />
                <div *ngIf="restoLat.invalid && (restoLat.dirty || restoLat.touched)" class="reqAlert">Latitude is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Longitude<span class="starReq">*</span></label>
                <input type="number" placeholder="enter restaurant longitude" class="form-control"
                  [(ngModel)]="restoLogitude" #restoLog="ngModel" name="restoLog" required />
                <div *ngIf="restoLog.invalid && (restoLog.dirty || restoLog.touched)" class="reqAlert">Latitude is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Service Charge (%)</label>
                <input type="number" placeholder="enter service charge" class="form-control"
                  [(ngModel)]="restoServiceCharge" name="serviceCharge" />
              </div>
              <div class="input-container">
                <label for="restoName">Spice Tolerance Level<span class="starReq">*</span></label>
                <select id="spice" class="form-select" #spice="ngModel" [(ngModel)]="spiceTol" name="spice" required>
                  <option value="" selected disabled>spice-rating</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
                <div *ngIf="spice.invalid && (spice.dirty || spice.touched)" class="reqAlert">Spice Tolerance is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Number Of Tables</label>
                <input type="number" placeholder="enter number of tables" class="form-control" [(ngModel)]="noOfTable"
                  name="noOfTable" />
              </div>
              <!-- <div class="input-container">
                <label for="restoName">Offer Value (%)</label>
                <input type="number" placeholder="enter offer value" class="form-control" [(ngModel)]="offerValue"
                  name="offerValue" />
              </div> -->
              <div class="input-container">
                <label>Dietary preferences</label>
                <ng-select class="multi-select" [items]="allDieatary" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select dietary preferences"
                  (change)="onMaterialGroupChange($event)" name="Dietary" [(ngModel)]="createdNewSelectedDieatry">
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Allergens</label>
                <ng-select class="multi-select" [items]="allAllergens" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select allergens"
                  (change)="onMaterialGroupChange($event)" name="Allergens" [(ngModel)]="createdNewSelectedAllegens">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Categories</label>
                <ng-select class="multi-select" [items]="allCaategory" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select categories"
                  (change)="onMaterialGroupChange($event)" name="Categories" [(ngModel)]="createdNewSelectedCaategory">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Cuisines</label>
                <ng-select class="multi-select" [items]="allCuisine" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select cuisines"
                  (change)="onMaterialGroupChange($event)" name="Cuisines" [(ngModel)]="createdNewSelectedCuisine">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label for="restoName">Featured image (less than 500kb)</label>
                <div style="display: flex;align-items: center;">
                  <span class="imgPreview"><img [src]="newFeatureSrc" alt="" /></span>
                  <span style="margin-left: 10px;">
                    <input type="file" accept="image/png,image/jpeg,"
                      (change)="onNewFeatureImgChange($event,'featureImgIdNew')" #fileInput_feature_image hidden
                      name="imgFile" id="featureImgIdNew" />
                    <button class="uploadBtn" (click)="fileInput_feature_image.click()">
                      <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                    </button>
                  </span>

                </div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Level <span class="starReq">*</span></label>
                <div style="display: flex;align-items: center;">
                  <select name="level-resto" id="level-resto" class="form-select" #level="ngModel"
                    [(ngModel)]="newRestoLevel" required>
                    <option value="" disabled selected>Select level</option>
                    <option value="L0">Level-0</option>
                    <option value="L1">Level-1</option>
                    <option value="B0">Sub Branch</option>
                  </select>
                </div>
                <div *ngIf="level.invalid && (level.dirty || level.touched)" class="reqAlert">Level of restaurant is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoLevel">Label</label>
                <input type="text" placeholder="Enter the label" class="form-control" [(ngModel)]="restoLavelLable"
                  name="restoLevel" />
              </div>
            </div>
            <div class="input-container">
              <label for="">Opening and closing hours</label>
              <div class="bigScreen">
                <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr;grid-gap: 10px;">
                  <div class="time-text">Select days</div>
                  <div class="time-text">Open timings</div>
                  <div class="time-text">Close timings</div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('mondayTime',$event.target)" [checked]="monPrecheck">
                    <div class="cuisine-name"> Monday </div>
                  </div>
                  <div id="mondayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH"
                      name="monOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM"
                      name="monOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="monOpenMead" name="monOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="mondayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH"
                      name="monCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM"
                      name="monCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="monCloseMead" name="monCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <span (click)="timeClear('mondayTime')" class="clear-timeBtn"
                      *ngIf="mondayClearCondition">Clear</span>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="tuePrecheck">
                    <div class="cuisine-name"> Tuesday </div>
                  </div>
                  <div id="tuesdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueOpenHH"
                      name="tueOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueOpenMM"
                      name="tueOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="tueOpenMead" name="tueOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="tuesdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH"
                      name="tueCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM"
                      name="tueCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="tueCloseMead" name="tueCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                        *ngIf="tuesdayClearCondition">Clear</span>
                      <div
                        *ngIf="tuesdayClearCondition && monOpenHH.length != 0 && monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="tuesdayClearCondition && monOpenHH.length != 0&& monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0 "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('tue')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('wednesTime',$event.target)" [checked]="wedPrecheck">
                    <div class="cuisine-name"> Wednesday </div>
                  </div>
                  <div id="wednesTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedOpenHH"
                      name="wedOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedOpenMM"
                      name="wedOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="wedOpenMead" name="wedOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="wednesTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH"
                      name="wedCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM"
                      name="wedCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="wedCloseMead" name="wedCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('wednesTime')" class="clear-timeBtn"
                        *ngIf="wednesdayClearCondition">Clear</span>
                      <div
                        *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('wed')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="thurPrecheck">
                    <div class="cuisine-name"> Thursday </div>
                  </div>
                  <div id="thursdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurOpenHH"
                      name="thurOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurOpenMM"
                      name="thurOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="thurOpenMead" name="thurOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="thursdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurCloseHH"
                      name="thurCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurCloseMM"
                      name="thurCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="thurCloseMead" name="thurCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                        *ngIf="tursdayClearCondition">Clear</span>
                      <div
                        *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('thur')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('fridayTime',$event.target)" [checked]="friPrecheck">
                    <div class="cuisine-name"> Friday </div>
                  </div>
                  <div id="fridayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friOpenHH"
                      name="friOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friOpenMM"
                      name="friOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="friOpenMead" name="friOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="fridayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH"
                      name="friCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="friCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="friCloseMead" name="friCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>

                    <div class="clear-copyDiv">
                      <span (click)="timeClear('fridayTime')" class="clear-timeBtn"
                        *ngIf="fridayClearCondition">Clear</span>
                      <div
                        *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('fri')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="satPrecheck">
                    <div class="cuisine-name"> Saturday </div>
                  </div>
                  <div id="saturdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satOpenHH"
                      name="satOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satOpenMM"
                      name="satOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="satOpenMead" name="satOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="saturdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH"
                      name="satCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM"
                      name="satCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="satCloseMead" name="satCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                        *ngIf="saturdayClearCondition">Clear</span>
                      <div
                        *ngIf="saturdayClearCondition && friOpenHH.length != 0 && friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="saturdayClearCondition && friOpenHH.length != 0 &&friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sat')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('sundayTime',$event.target)" [checked]="sunPrecheck">
                    <div class="cuisine-name"> Sunday </div>
                  </div>
                  <div id="sundayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunOpenHH"
                      name="sunOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunOpenMM"
                      name="sunOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="sunOpenMead" name="sunOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="sundayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH"
                      name="sunCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM"
                      name="sunCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="sunCloseMead" name="sunCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('sundayTime')" class="clear-timeBtn"
                        *ngIf="sundayClearCondition">Clear</span>
                      <div
                        *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sun')">
                        Copy
                      </button>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="input-container">
              <label for="">Special offers on specific days</label>
              <div class="time-text">Select days</div>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('mon',$event.target)" [(checked)]="offerMonday">
                    <div class="cuisine-name"> Monday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerMonday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerMonValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerMonday" [(ngModel)]="offerMonValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('tue',$event.target)" [(checked)]="offerTuesday">
                    <div class="cuisine-name"> Tuesday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerTuesday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerTueValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerTuesday" [(ngModel)]="offerTueValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('wed',$event.target)" [(checked)]="offerWednesday">
                    <div class="cuisine-name"> Wednesday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerWednesday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerWedValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerWednesday" [(ngModel)]="offerWedValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('thu',$event.target)" [(checked)]="offerTurusday">
                    <div class="cuisine-name"> Thursday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerTurusday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerThurValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerTurusday" [(ngModel)]="offerThurValue">
                  </div>

                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('fri',$event.target)" [(checked)]="offerFriday">
                    <div class="cuisine-name"> Friday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerFriday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerFriValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerFriday" [(ngModel)]="offerFriValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('sat',$event.target)" [(checked)]="offerSaturday">
                    <div class="cuisine-name"> Saturday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerSaturday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerSatValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerSaturday" [(ngModel)]="offerSatValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('sun',$event.target)" [(checked)]="offerSunday">
                    <div class="cuisine-name"> Sunday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerSunday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerSunValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerSunday" [(ngModel)]="offerSunValue">
                  </div>
                </div>
              </div>
            </div>
            <div class="input-container">
              <label for="">Appropriate food allergy message</label>
              <div style="margin-left: 15px;">
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" value="a" class="form-radio form-check-input"
                    (change)="queAns = 'A'" [checked]="preRadioSelect('A')">
                  <span class="cuisine-name" style="display: block;">a. Currently we cannot provide an allergen free
                    preparation in our
                    kitchen.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'B'" [checked]="preRadioSelect('B')">
                  <span class="cuisine-name" style="display: block;">b. We strive hard to cater to some food allergies
                    or
                    intolerances if our
                    customers
                    communicate specific allergies or intolerances to us before placing the order
                    but cannot guarntee allergen free dishes.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'C'" [checked]="preRadioSelect('C')">
                  <span class="cuisine-name" style="display: block;">c. We cater to some food allergies and are
                    committed
                    avoid cross contamination
                    in our kitchen.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'D'" [checked]="preRadioSelect('D')">
                  <span class="cuisine-name" style="display: block;">d. Other</span>
                  <textarea name=" appropriateFoodAllergyMessage"
                    placeholder="Please give appropriate food allergy message" *ngIf="queAns == 'D'"
                    class="form-control" style="margin-top: 25px;" [(ngModel)]="queAnsOtherText"></textarea>
                </div>
              </div>
            </div>
            <div class="input-container">

              <label>Menu (image should be less than 500kb)</label>
              <div *ngIf="menuSrc.length != 0" class="menu-img-preview-main">
                <div *ngFor="let item of menuSrc; let i =index"
                  style="width: 30%;margin-right: 10px; margin-bottom: 20px;display: flex;align-items: flex-start;">
                  <img [src]="item.src" alt="menu img">
                  <img src="../../../assets/images/Cancel.png" alt=""
                    style="position: relative; top: -6px;right: 14px; cursor: pointer;" (click)="menuImgDelete(i,item)">
                </div>
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event,'menuImgDelete1')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete1" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
              </div>
              <div *ngIf="pdfMenuSrc != 'null' && menuSrc.length == 0 ">
                <span class="pdfMainSpan">
                  <img src="../../../assets/img/pdf-icon.png" alt="" (click)="openpdf()">
                  <span style="overflow-wrap: anywhere; margin: auto 0;" (click)="openpdf()">{{pdfMenuSrc}}</span>
                  <img src="../../../assets/img/close-red-icon.png" alt=""
                    style="width: 17px;height: 17px;margin:auto 0; cursor:pointer" (click)="pdfDelete()">
                </span>
              </div>
              <div class="menu-first-div" *ngIf="menuSrc.length == 0 && pdfMenuSrc == 'null'">
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event,'menuImgDelete2')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete2" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
                <div>or</div>
                <div class="addBtn-mainDiv" (click)="menuLinkInsert()">
                  <img src="../../../assets/images/insert.png" alt="">
                  <span>Insert link</span>
                </div>

              </div>
              <div *ngIf="menuLinkCondition">
                <div style="font-size: 16px; line-height: 23px; color: #737373;">Please enter the link</div>
                <input type="url" name="urlLink" id="" class="form-control" style="width: 90%;" spellcheck="false"
                  [(ngModel)]="urlLink">
                <!-- <button (click)="openMenuUrlLink(urlLink)" class="common">Open url in new tab</button> -->
              </div>

            </div>
            <div class="input-container">
              <label for="">Delivary Partner</label>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('deliveroo', $event.target)" [(checked)]="delverooCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/delivero-icon.png"
                        alt="" srcset="" style="max-width: 65px;"> Deliveroo </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="delverooCon">
                    <input type="url" name="delverooVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="delverooVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('justEat', $event.target)" [(checked)]="justEatCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/just-eat-icon.png"
                        alt="" srcset="" style="max-width: 65px;"> JustEat </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="justEatCon">
                    <input type="url" name="justEatVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                      [(ngModel)]="justEatVal" placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('uberEats', $event.target)" [(checked)]="uberEatsCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/uber-eats-icon.png"
                        alt="" srcset="" style="width:65px;"> Uber Eats </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="uberEatsCon">
                    <input type="url" name="uberEatsVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="uberEatsVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('foodstuff', $event.target)" [(checked)]="foodstuffCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/foodstuff-removebg-preview.png" alt="" srcset=""
                        style="max-width: 65px;">
                      Foodstuff </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="foodstuffCon">
                    <input type="url" name="foodstuffVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="foodstuffVal"
                      placeholder="Please give the link">
                  </div>
                </div>
              </div>

            </div>
            <div class="input-container">
              <label for="">Social Links</label>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('instagram', $event.target)" [(checked)]="instagramCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;">
                      Instagram </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="instagramCon">
                    <input type="url" name="instagramVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="instagramVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                        style="max-width: 65px;"> Facebook </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="facebookCon">
                    <input type="url" name="facebookVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="facebookVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('googleMap', $event.target)" [(checked)]="googleMapCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset=""
                        style="max-width: 65px;"> Google Map </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="googleMapCon">
                    <input type="url" name="googleMapVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="googleMapVal"
                      placeholder="Please give the link">
                  </div>
                </div>
              </div>

            </div>
            <div class="input-container">
              <label for="">Please add any other description or tags that are associated and relevant to your Food
                business separated by commas.</label>
              <textarea name="otherDescriptionOrTags" id="" cols="30" rows="10"
                placeholder="Example: Pool table, Board games, Proper pub, Nice Wine collection, Wine and Cheese, etc"
                class="form-control" style="height:100px" [(ngModel)]="otherDescriptionOrTags"></textarea>

            </div>
            <!--the below code is for Restaurant Opening Hours, Closing Hours along with add button which will take multiple opening and closing hours.
                One button is also for taking multiple days. Waiting Hours is also below in the code -->
            <!-- <div>
                  <div class="opningHoursText">Restaurant Opening Hours</div>
                  <div
                    class="flex openingHoursContainer"
                    *ngFor="let item of dayArr; let j = index"
                  >
                    <div>
                      <div class="text-center">Select Days</div>
                      <div>
                        <select name="openingDays" id="" class="form-select dayDrop">
                          <option value="all">All Day</option>
                          <option value="monday">Monday</option>
                          <option value="tuesday">Tuesday</option>
                          <option value="wednesday">Wednesday</option>
                          <option value="thursday">Thursday</option>
                          <option value="friday">Friday</option>
                          <option value="saturday">Saturday</option>
                          <option value="sunday">Sunday</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      <div
                        class="flex addPart"
                        *ngFor="let item of timeArr; let i = index"
                      >
                        <div>
                          <div class="text-center">Open Timings</div>
                          <div class="flex main-time-box">
                            <span class="input-time-field">
                              <input
                                type="number"
                                class="form-control"
                                name="openingHours"
                              />
                              <label for="openingHours" class="timeInfo">Hours</label>
                            </span>
                            <span class="time-divider">:</span>
                            <span class="input-time-field">
                              <input
                                type="number"
                                class="form-control"
                                name="openingMins"
                              />
                              <label for="openingHours" class="timeInfo">Minutes</label>
                            </span>
                            <div class="am-pm-container">
                              <input
                                type="radio"
                                class="btn-check"
                                id="{{ j }}{{ i }}am"
                                autocomplete="off"
                                name="{{ j }}{{ i }}am-pm"
                                checked="checked"
                              />
                              <label class="btn" for="{{ j }}{{ i }}am">AM</label><br />
                              <input
                                type="radio"
                                class="btn-check"
                                id="{{ j }}{{ i }}pm"
                                autocomplete="off"
                                name="{{ j }}{{ i }}am-pm"
                              />
                              <label class="btn" for="{{ j }}{{ i }}pm">PM</label>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="text-center">Close Timings</div>
                          <div class="flex main-time-box">
                            <span class="input-time-field">
                              <input
                                type="number"
                                class="form-control"
                                name="closingHours"
                              />
                              <label for="closingHours" class="timeInfo">Hours</label>
                            </span>
                            <span class="time-divider">:</span>
                            <span class="input-time-field">
                              <input
                                type="number"
                                class="form-control"
                                name="closingMins"
                              />
                              <label for="closingMins" class="timeInfo">Minutes</label>
                            </span>
                            <div class="am-pm-container">
                              <input
                                type="radio"
                                class="btn-check"
                                id="{{ j }}{{ i }}closeAM"
                                autocomplete="off"
                                name="{{ j }}{{ i }}close-am-pm"
                                checked="checked"
                              />
                              <label class="btn" for="{{ j }}{{ i }}closeAM">AM</label
                              ><br />
                              <input
                                type="radio"
                                class="btn-check"
                                id="{{ j }}{{ i }}closePM"
                                autocomplete="off"
                                name="{{ j }}{{ i }}close-am-pm"
                              />
                              <label class="btn" for="{{ j }}{{ i }}closePM">PM</label>
                            </div>
                            <div
                              class="flex"
                              style="align-items: center; margin-left: 10px"
                            >
                              <span (click)="timeAddBtn()"
                                ><img src="../../../assets/images/addTimeBtn.png" alt=""
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <span
                      (click)="dayAddBtn()"
                      style="margin-top: 65px; margin-left: 10px"
                      ><img src="../../../assets/images/addTimeComp.png" alt=""
                    /></span>
                   
                  </div>
                  <div style="display: inline-flex; flex-direction: column; float: right">
                    <div>
                      Restaurant Waiting Time<br />
                      (Hour : Minute)
                    </div>
                    <div class="flex">
                      <span class="input-time-field">
                        <input type="number" class="form-control" name="closingHours" />
                        <label for="closingHours" class="timeInfo">Hours</label>
                      </span>
                      <span class="time-divider">:</span>
                      <span class="input-time-field">
                        <input type="number" class="form-control" name="closingMins" />
                        <label for="closingMins" class="timeInfo">Minutes</label>
                      </span>
                    </div>
                  </div>
                </div> -->

            <!-- <div>
                  <div class="opningHoursText">Social Links</div>
                  <div
                    class="flex openingHoursContainer"
                    *ngFor="let item of mediaArr; let i = index"
                  >
                    <div>
                      <div class="text-center">Select Media</div>
                      <div>
                        <ng-select
                          [items]="cities3"
                          bindLabel="{{ i }}name"
                          bindValue="{{ i }}name"
                          placeholder="Select Media"
                          [(ngModel)]="selectedCityName"
                          [searchable]="false"
                          class="form-select dayDrop socialDrop"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            <img height="15" width="15" [src]="item.avatar" />
                            &nbsp; <b>{{ item.name }}</b>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item" let-index="index">
                            <img height="15" width="15" [src]="item.avatar" /> &nbsp;
                            <b>{{ item.name }}</b>
                          </ng-template>
                        </ng-select>
                      </div>
                    </div>
                    <div class="media-input-mainBox">
                      <div class="text-center">Enter the Link</div>
                      <input
                        type="text"
                        placeholder="Please Enter The Link"
                        class="form-control"
                      />
                    </div>
                    <span
                      (click)="mediaAddBtn()"
                      style="margin-top: 65px; margin-left: 10px"
                      ><img src="../../../assets/images/addTimeComp.png" alt=""
                    /></span>
                  </div>
                </div>
                <div style="margin-top: 50px">
                  <div class="form-check form-switch">
                    <label class="form-check-label" for="flexSwitchCheckDefault"
                      >Accept take away orders</label
                    >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                  <div class="form-check form-switch">
                    <label class="form-check-label" for="flexSwitchCheckDefault"
                      >Display Nutritional<br />
                      Information</label
                    >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckDefault"
                    />
                  </div>
                </div> -->
            <div class="flex buttomPartAddResto">
              <div class="common closeBtn" (click)="closeResto()">Close</div>
              <div class="common submitBtn" (click)="submitRestoCreate(restoAddData)">Submit</div>
            </div>
          </form>
        </div>
      </div>




      <div *ngIf="restopop == 2" class="addRestoMainContainer">
        <div class="restoHeadText">Restaurants Details</div>
        <div style="padding:0 20px">
          <form #editResto="ngForm">
            <div class="grid">
              <div class="input-container">
                <label for="restoName">Restaurant Name<span class="starReq">*</span></label>
                <input type="text" name="restoName" placeholder="enter the restaurant name" class="form-control"
                  [(ngModel)]="restoEditName" required #name="ngModel" />
                <div *ngIf="name.invalid && (name.dirty || name.touched)" class="reqAlert">Name is required</div>
              </div>

              <div class="input-container">
                <label for="emailId">Email ID<span class="starReq">*</span></label>
                <input type="text" name="emailId" placeholder="enter the email-id" class="form-control"
                  [(ngModel)]="restoEditEmail" #email="ngModel" required />
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="reqAlert">Email is required</div>
              </div>

              <div class="input-container">
                <label for="restoName">Restaurant Telephone<span class="starReq">*</span></label>
                <input type="text" placeholder="enter restaurant telephone" class="form-control"
                  [(ngModel)]="restoEditPhone" name="restoTel" #restoTel="ngModel" required />
                <div *ngIf="restoTel.invalid && (restoTel.dirty || restoTel.touched)" class="reqAlert">Telephone is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Logo (less than 500kb)<span class="starReq">*</span></label>
                <div>
                  <span class="imgPreview"><img [src]="editSrc" alt="" style="width: 44px;" alt="img" /></span>
                  <span>
                    <input type="file" accept="image/png,image/jpeg" (change)="oneEditImageChange($event,'restoLogoId')"
                      #fileInput_image_edit hidden name="imgFile" id="restoLogoId" />
                    <button class="uploadBtn" (click)="fileInput_image_edit.click()">
                      <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                    </button>
                  </span>

                </div>
              </div>
              <div class="input-container">
                <label for="restoName">Restaurant Address<span class="starReq">*</span></label>
                <textarea class="form-control" id="newRrestoAddress" rows="3" [(ngModel)]="restoEditAddress"
                  name="restoAdd" #restoAdd="ngModel" required></textarea>
                <div *ngIf="restoAdd.invalid && (restoAdd.dirty || restoAdd.touched)" class="reqAlert">Address is
                  required</div>
              </div>
              <div class="input-container">
                <label for="newRrestoDescription">Restaurant Descriptions</label>
                <textarea class="form-control" id="newRrestoDescription" rows="3" [(ngModel)]="restoEditDescrip"
                  name="rstoDescp"></textarea>
              </div>
              <div class="input-container">
                <label for="pocName">POC Name</label>
                <input type="text" placeholder="enter the POC name" class="form-control" [(ngModel)]="restoEditPocName"
                  name="pocName" />
              </div>
              <div class="input-container">
                <label for="pocId">POC ID</label>
                <input type="text" placeholder="enter the POC ID" class="form-control" [(ngModel)]="restoEditPocId"
                  name="pocId" />
              </div>
              <div class="input-container">
                <label for="restoLat">Restaurant Latitude<span class="starReq">*</span></label>
                <input type="text" placeholder="enter restaurant latitude" class="form-control"
                  [(ngModel)]="restoEditLotitude" name="restoLat" #restoLat="ngModel" required />
                <div *ngIf="restoLat.invalid && (restoLat.dirty || restoLat.touched)" class="reqAlert">Latitude is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoLog">Restaurant Longitude<span class="starReq">*</span></label>
                <input type="text" placeholder="enter restaurant longitude" class="form-control"
                  [(ngModel)]="restoEditLogitude" name="restoLog" #restoLog="ngModel" required />
                <div *ngIf="restoLog.invalid && (restoLog.dirty || restoLog.touched)" class="reqAlert">Longitude is
                  required</div>
              </div>
              <div class="input-container">
                <label for="serviceCharge">Service Charge (%)</label>
                <input type="text" placeholder="enter service charge" class="form-control"
                  [(ngModel)]="restoEditServiceCharge" name="serviceCharge" />
              </div>
              <div class="input-container">
                <label for="spice">Spice Tolerance Level<span class="starReq">*</span></label>
                <select id="spice" class="form-select" [(ngModel)]="spiceEditTol" name="spice" #spice="ngModel"
                  required>
                  <option value="" selected disabled>spice-rating</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
                <div *ngIf="spice.invalid && (spice.dirty || spice.touched)" class="reqAlert">Spice Tolerance is
                  required</div>
              </div>
              <div class="input-container">
                <label for="restoName">Number Of Tables</label>
                <input type="text" placeholder="enter number of tables" class="form-control" [(ngModel)]="noOfEditTable"
                  name="noOfTable" />
              </div>
              <!-- <div class="input-container">
                <label for="restoName">Offer Value (%)</label>
                <input type="text" placeholder="enter offer value" name="offerValue" class="form-control"
                  [(ngModel)]="editOfferValue" />
              </div> -->
              <div class="input-container">
                <label>Dietary preferences</label>
                <ng-select class="multi-select" [items]="allDieatary" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select dietary preferences"
                  (change)="onMaterialGroupChange($event)" name="Dietary" [(ngModel)]="selectedDieatry">
                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Allergens</label>
                <ng-select class="multi-select" [items]="allAllergens" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select allergens"
                  (change)="onMaterialGroupChange($event)" name="Allergens" [(ngModel)]="selectedAllegens">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Categories</label>
                <ng-select class="multi-select" [items]="allCaategory" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select categories"
                  (change)="onMaterialGroupChange($event)" name="Categories" [(ngModel)]="selectedCaategory">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label>Cuisines</label>
                <ng-select class="multi-select" [items]="allCuisine" bindLabel="name" bindValue="id" [multiple]="true"
                  groupBy="selectedAllGroup" [selectableGroup]="true" placeholder="Select cuisines"
                  (change)="onMaterialGroupChange($event)" name="Cuisines" [(ngModel)]="selectedCuisine">

                  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                  </ng-template>
                </ng-select>
              </div>
              <div class="input-container">
                <label for="restoName">Featured image (less than 500kb)</label>
                <div style="display: flex;align-items: center;">
                  <span class="imgPreview"><img [src]="featureSrc" alt="" /></span>
                  <span style="margin-left: 10px;">
                    <input type="file" accept="image/png,image/jpeg,"
                      (change)="onFeatureImgChange($event,'featureImgId')" #fileInput_feature_image hidden
                      name="imgFile" id="featureImgId" />
                    <button class="uploadBtn" (click)="fileInput_feature_image.click()">
                      <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                    </button>
                  </span>

                </div>
              </div>
              <!-- <div class="input-container">
                <label for="restoName">Restaurant Level</label>
                <div style="display: flex;align-items: center;">
                  <select name="" id="" class="form-select" [(ngModel)]="restoLevel">
                    <option value="L0">Level-0</option>
                    <option value="L1">Level-1</option>
                    <option value="B0">Sub Branch</option>
                  </select>
                </div>
              </div> -->
              <div class="input-container">
                <label for="restoLevel">Label</label>
                <input type="text" placeholder="Enter the label" class="form-control" [(ngModel)]="restoEditLavelLable"
                  name="restoLevel" />
              </div>
            </div>
            <div class="input-container">
              <label for="">Opening and closing hours</label>
              <div class="bigScreen">
                <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr;grid-gap: 10px;">
                  <div class="time-text">Select days</div>
                  <div class="time-text">Open timings</div>
                  <div class="time-text">Close timings</div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('mondayTime',$event.target)" [checked]="monPrecheck">
                    <div class="cuisine-name"> Monday </div>
                  </div>
                  <div id="mondayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH"
                      name="monOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM"
                      name="monOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="monOpenMead" name="monOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="mondayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH"
                      name="monCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM"
                      name="monCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="monCloseMead" name="monCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <span (click)="timeClear('mondayTime')" class="clear-timeBtn"
                      *ngIf="mondayClearCondition">Clear</span>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="tuePrecheck">
                    <div class="cuisine-name"> Tuesday </div>
                  </div>
                  <div id="tuesdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueOpenHH"
                      name="tueOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueOpenMM"
                      name="tueOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="tueOpenMead" name="tueOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="tuesdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH"
                      name="tueCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM"
                      name="tueCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="tueCloseMead" name="tueCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('tuesdayTime')" class="clear-timeBtn"
                        *ngIf="tuesdayClearCondition">Clear</span>
                      <div
                        *ngIf="tuesdayClearCondition && monOpenHH.length != 0 && monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="tuesdayClearCondition && monOpenHH.length != 0&& monOpenMM.length != 0 && monCloseHH.length != 0 && monCloseMM.length != 0 "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('tue')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('wednesTime',$event.target)" [checked]="wedPrecheck">
                    <div class="cuisine-name"> Wednesday </div>
                  </div>
                  <div id="wednesTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedOpenHH"
                      name="wedOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedOpenMM"
                      name="wedOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="wedOpenMead" name="wedOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="wednesTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH"
                      name="wedCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM"
                      name="wedCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="wedCloseMead" name="wedCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('wednesTime')" class="clear-timeBtn"
                        *ngIf="wednesdayClearCondition">Clear</span>
                      <div
                        *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="wednesdayClearCondition && tueOpenHH.length != 0 && tueOpenMM.length != 0 && tueCloseHH.length != 0 && tueCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('wed')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="thurPrecheck">
                    <div class="cuisine-name"> Thursday </div>
                  </div>
                  <div id="thursdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurOpenHH"
                      name="thurOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurOpenMM"
                      name="thurOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="thurOpenMead" name="thurOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="thursdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="thurCloseHH"
                      name="thurCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="thurCloseMM"
                      name="thurCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="thurCloseMead" name="thurCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('thursdayTime')" class="clear-timeBtn"
                        *ngIf="tursdayClearCondition">Clear</span>
                      <div
                        *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="tursdayClearCondition && wedOpenHH.length != 0 && wedOpenMM.length != 0 && wedCloseHH.length != 0 && wedCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('thur')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('fridayTime',$event.target)" [checked]="friPrecheck">
                    <div class="cuisine-name"> Friday </div>
                  </div>
                  <div id="fridayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friOpenHH"
                      name="friOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="friOpenMM"
                      name="friOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="friOpenMead" name="friOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="fridayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH"
                      name="friCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM"
                      [(ngModel)]="friCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="friCloseMead" name="friCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>

                    <div class="clear-copyDiv">
                      <span (click)="timeClear('fridayTime')" class="clear-timeBtn"
                        *ngIf="fridayClearCondition">Clear</span>
                      <div
                        *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="fridayClearCondition && thurOpenHH.length != 0 && thurOpenMM.length != 0 && thurCloseHH.length != 0 && thurCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('fri')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="satPrecheck">
                    <div class="cuisine-name"> Saturday </div>
                  </div>
                  <div id="saturdayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satOpenHH"
                      name="satOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satOpenMM"
                      name="satOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="satOpenMead" name="satOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="saturdayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH"
                      name="satCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM"
                      name="satCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="satCloseMead" name="satCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('saturdayTime')" class="clear-timeBtn"
                        *ngIf="saturdayClearCondition">Clear</span>
                      <div
                        *ngIf="saturdayClearCondition && friOpenHH.length != 0 && friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="saturdayClearCondition && friOpenHH.length != 0 &&friOpenMM.length != 0 && friCloseHH.length != 0 && friCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sat')">
                        Copy
                      </button>
                    </div>
                  </div>
                  <div style="display: flex; margin-bottom :15px;">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="timeInputFunc('sundayTime',$event.target)" [checked]="sunPrecheck">
                    <div class="cuisine-name"> Sunday </div>
                  </div>
                  <div id="sundayTimeOpen">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunOpenHH"
                      name="sunOpenHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunOpenMM"
                      name="sunOpenMM" />
                    <select class="time-selectOption" [(ngModel)]="sunOpenMead" name="sunOpenMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                  </div>
                  <div id="sundayTimeClose">
                    <input name="" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH"
                      name="sunCloseHH" />
                    <span>:</span>
                    <input name="somename" class="time-input"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                      type="text" (keypress)="validate($event)" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM"
                      name="sunCloseMM" />
                    <select class="time-selectOption" [(ngModel)]="sunCloseMead" name="sunCloseMead">
                      <option value="am" selected>AM</option>
                      <option value="pm">PM</option>
                    </select>
                    <div class="clear-copyDiv">
                      <span (click)="timeClear('sundayTime')" class="clear-timeBtn"
                        *ngIf="sundayClearCondition">Clear</span>
                      <div
                        *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0">
                        |</div>
                      <button
                        *ngIf="sundayClearCondition && satOpenHH.length != 0 && satOpenMM.length != 0 && satCloseHH.length != 0 && satCloseMM.length != 0   "
                        mat-raised-button #tooltip="matTooltip" matTooltip="Copy time from previous day"
                        [matTooltipPosition]="position.value!" matTooltipHideDelay="100000" mdTooltipClass="toolTip"
                        aria-label="Copy time from previous day" class="example-button" (click)="copyTimeFunc('sun')">
                        Copy
                      </button>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="input-container">
              <label for="">Special offers on specific days</label>
              <div class="time-text">Select days</div>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('mon',$event.target)" [(checked)]="offerMonday">
                    <div class="cuisine-name"> Monday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerMonday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerMonValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerMonday" [(ngModel)]="offerMonValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('tue',$event.target)" [(checked)]="offerTuesday">
                    <div class="cuisine-name"> Tuesday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerTuesday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerTueValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerTuesday" [(ngModel)]="offerTueValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('wed',$event.target)" [(checked)]="offerWednesday">
                    <div class="cuisine-name"> Wednesday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerWednesday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerWedValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerWednesday" [(ngModel)]="offerWedValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('thu',$event.target)" [(checked)]="offerTurusday">
                    <div class="cuisine-name"> Thursday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerTurusday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerThurValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerTurusday" [(ngModel)]="offerThurValue">
                  </div>

                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('fri',$event.target)" [(checked)]="offerFriday">
                    <div class="cuisine-name"> Friday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerFriday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerFriValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerFriday" [(ngModel)]="offerFriValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('sat',$event.target)" [(checked)]="offerSaturday">
                    <div class="cuisine-name"> Saturday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerSaturday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerSatValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerSaturday" [(ngModel)]="offerSatValue">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="offerHandelFunc('sun',$event.target)" [(checked)]="offerSunday">
                    <div class="cuisine-name"> Sunday </div>
                  </div>
                  <div class="offer-sub-div">
                    <!-- <div class="offer-div" *ngIf="offerSunday">Offer Discount (%)</div> -->
                    <input type="text" placeholder="Description of special event/discount" name="offerSunValue" id=""
                      class="form-control" style="width: 55%;" *ngIf="offerSunday" [(ngModel)]="offerSunValue">
                  </div>
                </div>
              </div>
            </div>
            <div class="input-container">
              <label for="">Appropriate food allergy message</label>
              <div style="margin-left: 15px;">
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" value="a" class="form-radio form-check-input"
                    (change)="queAns = 'A'" [checked]="preRadioSelect('A')">
                  <span class="cuisine-name" style="display: block;">a. Currently we cannot provide an allergen free
                    preparation in our
                    kitchen.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'B'" [checked]="preRadioSelect('B')">
                  <span class="cuisine-name" style="display: block;">b. We strive hard to cater to some food allergies
                    or
                    intolerances if our
                    customers
                    communicate specific allergies or intolerances to us before placing the order
                    but cannot guarntee allergen free dishes.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'C'" [checked]="preRadioSelect('C')">
                  <span class="cuisine-name" style="display: block;">c. We cater to some food allergies and are
                    committed
                    avoid cross contamination
                    in our kitchen.</span>
                </div>
                <div style="margin-bottom: 15px;">
                  <input type="radio" name="allergenMsg" id="" class="form-radio form-check-input"
                    (change)="queAns = 'D'" [checked]="preRadioSelect('D')">
                  <span class="cuisine-name" style="display: block;">d. Other</span>
                  <textarea name=" appropriateFoodAllergyMessage"
                    placeholder="Please give appropriate food allergy message" *ngIf="queAns == 'D'"
                    class="form-control" style="margin-top: 25px;" [(ngModel)]="queAnsOtherText"></textarea>
                </div>
              </div>
            </div>
            <div class="input-container">

              <label>Menu (image should be less than 500kb)</label>
              <div *ngIf="menuSrc.length != 0" class="menu-img-preview-main">
                <div *ngFor="let item of menuSrc; let i =index"
                  style="width: 30%;margin-right: 10px; margin-bottom: 20px;display: flex;align-items: flex-start;">
                  <img [src]="item.src" alt="menu img">
                  <img src="../../../assets/images/Cancel.png" alt=""
                    style="position: relative; top: -6px;right: 14px; cursor: pointer;" (click)="menuImgDelete(i,item)">
                </div>
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event,'menuImgDelete1')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete1" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
              </div>
              <div *ngIf="pdfMenuSrc != 'null' && menuSrc.length == 0 ">
                <span class="pdfMainSpan">
                  <img src="../../../assets/img/pdf-icon.png" alt="" (click)="openpdf()">
                  <span style="overflow-wrap: anywhere; margin: auto 0;" (click)="openpdf()">{{pdfMenuSrc}}</span>
                  <img src="../../../assets/img/close-red-icon.png" alt=""
                    style="width: 17px;height: 17px;margin:auto 0; cursor:pointer" (click)="pdfDelete()">
                </span>
              </div>
              <div class="menu-first-div" *ngIf="menuSrc.length == 0 && pdfMenuSrc == 'null'">
                <div class="addBtn-mainDiv" (click)="fileInput_Menu_image.click()">
                  <input type="file" accept="image/png,image/jpeg,application/pdf"
                    (change)="onMenuChange($event,'menuImgDelete2')" #fileInput_Menu_image hidden name="imgFile"
                    id="menuImgDelete2" />
                  <img src="../../../assets/images/upLogo.png" alt="">
                  <span>Add file</span>
                </div>
                <div>or</div>
                <div class="addBtn-mainDiv" (click)="menuLinkInsert()">
                  <img src="../../../assets/images/insert.png" alt="">
                  <span>Insert link</span>
                </div>

              </div>
              <div *ngIf="menuLinkCondition">
                <div style="font-size: 16px; line-height: 23px; color: #737373;">Please enter the link</div>
                <input type="url" name="urlLink" id="" class="form-control" style="width: 90%;" spellcheck="false"
                  [(ngModel)]="urlLink">
                <!-- <button (click)="openMenuUrlLink(urlLink)" class="common">Open url in new tab</button> -->
              </div>

            </div>
            <div class="input-container">
              <label for="">Delivary Partner</label>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('deliveroo', $event.target)" [(checked)]="delverooCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/delivero-icon.png"
                        alt="" srcset="" style="max-width: 65px;"> Deliveroo </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="delverooCon">
                    <input type="url" name="delverooVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="delverooVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('justEat', $event.target)" [(checked)]="justEatCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/just-eat-icon.png"
                        alt="" srcset="" style="max-width: 65px;"> JustEat </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="justEatCon">
                    <input type="url" name="justEatVal" id="" class="form-control" style="width: 200px; margin: auto 0;"
                      [(ngModel)]="justEatVal" placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('uberEats', $event.target)" [(checked)]="uberEatsCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img src="../../../assets/img/uber-eats-icon.png"
                        alt="" srcset="" style="width:65px;"> Uber Eats </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="uberEatsCon">
                    <input type="url" name="uberEatsVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="uberEatsVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="delevryHandelFunc('foodstuff', $event.target)" [(checked)]="foodstuffCon"
                      style="margin-top: 16px;">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/foodstuff-removebg-preview.png" alt="" srcset=""
                        style="max-width: 65px;">
                      Foodstuff </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="foodstuffCon">
                    <input type="url" name="foodstuffVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="foodstuffVal"
                      placeholder="Please give the link">
                  </div>
                </div>
              </div>

            </div>
            <div class="input-container">
              <label for="">Social Links</label>
              <div style="margin-left: 15px;">
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('instagram', $event.target)" [(checked)]="instagramCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset="" style="max-width: 65px;">
                      Instagram </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="instagramCon">
                    <input type="url" name="instagramVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="instagramVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                        style="max-width: 65px;"> Facebook </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="facebookCon">
                    <input type="url" name="facebookVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="facebookVal"
                      placeholder="Please give the link">
                  </div>
                </div>
                <div class="offer-main-div">
                  <div class="offer-sub-div">
                    <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                      (change)="socialLinkHandelFunc('googleMap', $event.target)" [(checked)]="googleMapCon">
                    <div class="cuisine-name" style="margin-top: 0;"> <img
                        src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset=""
                        style="max-width: 65px;"> Google Map </div>
                  </div>
                  <div class="offer-sub-div" *ngIf="googleMapCon">
                    <input type="url" name="googleMapVal" id="" class="form-control"
                      style="width: 200px; margin: auto 0;" [(ngModel)]="googleMapVal"
                      placeholder="Please give the link">
                  </div>
                </div>
              </div>

            </div>
            <div class="input-container">
              <label for="">Please add any other description or tags that are associated and relevant to your Food
                business separated by commas.</label>
              <textarea name="otherDescriptionOrTags" id="" cols="30" rows="10"
                placeholder="Example: Pool table, Board games, Proper pub, Nice Wine collection, Wine and Cheese, etc"
                class="form-control" style="height:100px" [(ngModel)]="otherDescriptionOrTags"></textarea>

            </div>
            <div class="flex buttomPartAddResto">
              <div class="common closeBtn" (click)="closeEditFunc()">Close</div>
              <div class="common submitBtn" (click)="submitEditRestoCreate(editResto)">Submit</div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- popups -->

    <!--
          <div class="delete-popup-container" *ngIf="delete">
            <div class="delete-popup-text">Are you sure you want to delete this restaurant?</div>
            <div class="delete-popup-conform">
              <span (click)="deleteRestoFunc()">No</span>
              <span>Yes</span>
            </div>
          </div> -->
    <!-- <button mat-raised-button (click)="openDialog('0ms', '0ms')">Open dialog without animation</button> -->
  </div>
</div>